'use client';
import React from 'react';
import Link from 'next/link';
import { notFound } from 'next/navigation';

export default function Error({ status, message }) {
  console.log(`status: ${status},message: ${message}`);
  if (message === 'NEXT_NOT_FOUND' || status === 410 || status === 404) {
    return notFound();
  }
  return (
    <div className="min-h-96 text-center py-12">
      <div className="text-9xl pt-6 pb-4 "></div>
      <div>
        <div className="text-xl font-bold mb-12">
          به نظر میاد مشکلی پیش اومده!
        </div>
        <Link
          className="  px-6 w-full hover:shadow-primary transition bg-color-primary text-white py-3 rounded-md text-sm SpAddTocartButton"
          href="/"
        >
          صفحه اصلی
        </Link>
      </div>
    </div>
  );
}
